import AbstractInstaller from "../../../core/application/AbstractInstaller";
import LanguagePackAddedEvent from "../../../core/language/controller/LanguagePackAddedEvent";
import InitRevisionToolTask from "./InitRevisionToolTask";
import LanguagePackRegistry from "./languagecontext/LanguagePackRegistry";
import RegisterLanguagePackCommand from "./languagecontext/RegisterLanguagePackCommand";
import RevisionToolGateway from "./RevisionToolGateway";

export default class RevisionToolInstaller extends AbstractInstaller {

    constructor(injector, commands, mediatorMap) {
        super(injector, commands, mediatorMap);

        //soma context:        
        injector.mapClass("revisionToolGateway", RevisionToolGateway, true);
        injector.mapClass("languagePackRegistry", LanguagePackRegistry, true);
        commands.add(LanguagePackAddedEvent.ADDED, RegisterLanguagePackCommand);

        //startup tasks:
        this._addStartupTask(InitRevisionToolTask, "InitRevisionTool");
    }
}